import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'src/app/core/core.module';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogTitle, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PipeModule } from 'src/app/core/pipes/pipe.module';
import { ReportComponent } from './report/report.component';
import { ConvertTokensComponent } from './convert-tokens/convert-tokens.component';

@NgModule({
  declarations: [
    // PaymentComponent
    ReportComponent,
    ConvertTokensComponent],
  imports: [
    CommonModule,
    CoreModule,
    MatTableModule,
    MatPaginatorModule,
    MatTooltipModule,
    PipeModule,
    MatSelectModule,
    MatRadioModule
  ],
  exports: [
    // PaymentComponent
    ReportComponent
  ],
  // entryComponents:[
  //   ReportComponent
  // ],
  providers: [
    { provide: MatDialogTitle, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
    { provide: MAT_DIALOG_DATA, useValue: [] },
  ]
})
export class GeneralModule { }
